module.exports = __webpack_public_path__ + "img/4-1.094fd10b.png";